import * as z from "zod";

export const themeFormSchema = z.object({
  name: z.string().min(1).max(255),
  description: z.string().optional(),
  color: z.string().max(32).optional(),
  status: z.enum(["active", "inactive"]).optional(),
});
